import SrInput from "./SrInput.vue";

SrInput.install = function(Vue) {
  Vue.component(SrInput.name, SrInput);
};

export default SrInput;


// WEBPACK FOOTER //
// ./packages/SrInput/index.js